import { isEmpty, map, pick } from 'lodash/fp';

import { CmsInsuranceTypeContent, Tile } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';
import { Tile as FormattedTile } from '../../../../../components/content-tiles-section/types';
import { TILE_VARIANTS } from '../../../../../ahm-constants/ui';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import insertFootnoteReference from '../../../../../utils/insert-footnote-reference';
import sortTiles from '../../../../../utils/sort-tiles';

const formatTiles = (tiles: Tile[]): FormattedTile[] =>
  map((tile) => {
    const { title, subtitle, footnote, imageObject, urlObject } = pick(
      ['title', 'subtitle', 'footnote', 'imageObject', 'urlObject'],
      tile,
    );

    const formattedFootnote = footnote
      ? {
          linkId: `footnote-${footnote}`,
          reference: footnote,
        }
      : null;

    const tileSubtitle = formattedFootnote
      ? insertFootnoteReference({ footnote: formattedFootnote, text: subtitle })
      : subtitle;

    const cta = urlObject ? [{ name: urlObject.name, url: urlObject.url }] : null;

    const image = getImageAttributes({ height: 240, imageObject });

    const formattedTile: FormattedTile = {
      // @ts-expect-error - Automatic, Please fix when editing this file
      ctas: cta,
      // @ts-expect-error - Automatic, Please fix when editing this file
      footnote: formattedFootnote,
      image: !isEmpty(image) ? image : null,
      subtitle: tileSubtitle,
      title,
      // @ts-ignore - Automatic, Please fix when editing this file
      urlObject,
    };

    return formattedTile;
  }, tiles);

type Props = {
  cmsSectionContent?: CmsInsuranceTypeContent['tiles'] | null;
};

const mapTiles = ({ cmsSectionContent }: Props) => {
  const tiles = cmsSectionContent;

  if (!tiles?.length) {
    return null;
  }

  const formattedTiles = formatTiles(tiles);
  const sortedTiles = sortTiles(formattedTiles, TILE_VARIANTS.VERTICAL_CENTER);

  return {
    content: sortedTiles,
    type: CONTENT_SECTIONS.TILES,
  };
};

export default mapTiles;
